export default __webpack_public_path__ + "static/media/zrx.302159ab.svg";